// extracted by mini-css-extract-plugin
export default {"container":"Tos_container__pNpcX","title":"Tos_title__-QhPP","subheading":"Tos_subheading__2q1L8"};